var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"based"},[_vm._v(_vm._s(_vm.$t("components.based_on.based_on"))+" "),_c('span',{staticClass:"feedaty-link"},[_vm._v(_vm._s(_vm.$t("components.based_on.feedaty")))])])}
var staticRenderFns = []

export { render, staticRenderFns }